import { useShowNotification } from '@inflearn/ds-react';
import { isNil } from 'lodash-es';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import type { ClientApiV1GuidesQueryString } from '../../../../resources/@types/accountSchema';
import { logger } from '../../../../resources/Logger';
import useClientGuidesQuery from '../../../queries/useClientGuidesQuery';
import { PolicyContentLayout } from './PolicyContentLayout';

type PolicyContentProps = {
  title: string;
  prevPolicy?: {
    href: string;
    buttonText?: string;
    description?: string;
  };
  type: ClientApiV1GuidesQueryString['type'];
  period: ClientApiV1GuidesQueryString['period'];
  isWebview?: boolean;
};

export const PolicyContent = ({
  title,
  prevPolicy,
  type,
  period,
  isWebview,
}: PolicyContentProps) => {
  const { t } = useTranslation();
  const { showNotification } = useShowNotification();

  const { data } = useClientGuidesQuery(
    { type, period },
    {
      suspense: true,
      useErrorBoundary: false,
      onError: (error) => {
        showNotification({
          title: t('특정 상거래법을 조회할 수 없습니다.'),
          type: 'error',
        });

        logger.error({
          type: 'API_ERROR',
          message: '특정 상거래법을 조회할 수 없습니다. (',
          payload: { type, period },
          error,
        });
      },
    },
  );

  useEffect(() => {
    const hash = window.location.hash;

    if (isNil(data?.content)) {
      return;
    }

    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView();
      }
    }
  }, [data?.content]);

  return (
    <PolicyContentLayout
      title={title}
      html={data?.content}
      prevPolicy={prevPolicy}
      isWebview={isWebview}
    />
  );
};
